import { render, staticRenderFns } from "./RoundDistribution.vue?vue&type=template&id=3c3f9ac8&scoped=true"
import script from "./RoundDistribution.vue?vue&type=script&lang=js"
export * from "./RoundDistribution.vue?vue&type=script&lang=js"
import style0 from "./RoundDistribution.vue?vue&type=style&index=0&id=3c3f9ac8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3f9ac8",
  null
  
)

export default component.exports